import { create } from 'zustand'
import { SCOPE } from '@/components/Schedules/scopeTabs'

/**
 * Which Pulse item the right-hand panel shows — `{ kind, id }` with kind one of
 * trigger | skill | template | update — and the Skills page's Mine/Discover
 * scope, which lives here so "Add to my skills" can flip it from the panel.
 */
export const usePulseUiStore = create((set) => ({
  open: null,
  skillsScope: SCOPE.MINE,
  openItem: (kind, id) => set({ open: { kind, id } }),
  close: () => set({ open: null }),
  setSkillsScope: (skillsScope) => set({ skillsScope }),
}))
